import { Fragment, useEffect, useState } from 'react';
import './KeywordMapStatsV4.css';
import KeywordStatItemV4 from '../keywordMapStats/keywordStatItem/KeywordStatItemV4';

const KeywordMapStatsV4 = ({
	keywordData,
	mobileReportView,
	showValue = true,
	selectable = false,
	onItemSelect,
	preselectValue = null
}) => {
	const [ itemAllSelected, setItemAllSelected ] = useState(false);
	const [ otherItemsSelectedValue, setOtherItemsSelectedValue ] = useState([]);

	useEffect(
		() => {
			setItemAllSelected(preselectValue === 'All');

			if (preselectValue === 'All') {
				setOtherItemsSelectedValue([]);
			}
		},
		[ preselectValue ]
	);

	const handleSelectItem = (itemSelected, label) => {
		if (onItemSelect) {
			if (label === 'All') {
				if (itemSelected) {
					setItemAllSelected(true);
					setOtherItemsSelectedValue([]);
				}
			} else {
				let tempOtherItemsSelected = [ ...otherItemsSelectedValue ];

				if (itemSelected) {
					setItemAllSelected(false);

					tempOtherItemsSelected.push(label);
				} else {
					tempOtherItemsSelected = tempOtherItemsSelected.filter((x) => x !== label);
				}

				setOtherItemsSelectedValue(tempOtherItemsSelected);
			}

			onItemSelect(itemSelected, label);
		}
	};

	return (
		<div className="keyword-map-stats-v4">
			{keywordData && (
				<Fragment>
					<KeywordStatItemV4
						label={selectable ? 'All' : 'Average'}
						changeSymbol="%"
						value={showValue ? keywordData.averageRank || 0 : ''}
						change={keywordData.averageRankChangePercentage || ''}
						selectable={selectable}
						onItemSelect={handleSelectItem}
						isSelected={itemAllSelected}
					/>

					{mobileReportView && <div className="flex-line-break" />}

					<KeywordStatItemV4
						label="Top 3"
						value={showValue ? keywordData.top3 || 0 : ''}
						change={keywordData.top3Change || ''}
						selectable={selectable}
						onItemSelect={handleSelectItem}
						isSelected={otherItemsSelectedValue.includes('Top 3')}
					/>
					<KeywordStatItemV4
						label="4-10"
						value={showValue ? keywordData.top10 || 0 : ''}
						change={keywordData.top10Change || ''}
						selectable={selectable}
						onItemSelect={handleSelectItem}
						isSelected={otherItemsSelectedValue.includes('4-10')}
					/>

					{mobileReportView && <div className="flex-line-break" />}

					<KeywordStatItemV4
						label="11-20"
						value={showValue ? keywordData.top20 || 0 : ''}
						change={keywordData.top20Change || ''}
						selectable={selectable}
						onItemSelect={handleSelectItem}
						isSelected={otherItemsSelectedValue.includes('11-20')}
					/>
					<KeywordStatItemV4
						label="21+"
						value={showValue ? keywordData.over20 || 0 : ''}
						change={keywordData.over20Change || ''}
						selectable={selectable}
						onItemSelect={handleSelectItem}
						isSelected={otherItemsSelectedValue.includes('21+')}
					/>
				</Fragment>
			)}
		</div>
	);
};

export default KeywordMapStatsV4;
